module.exports = __webpack_public_path__ + "static/media/dots.23fe7aeb.png";